/* istanbul ignore file */
import { Route, createRoute } from 'framework/routing';
import { Routes } from 'react-router-dom';
import { ProtectedRouter } from 'infrastructure/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { READ_NEW_COMPETENCY_LIST } from 'domain/people/career/qualification/newCompetency/newCompetencyService';
import NewQualificationModelViewPage from 'domain/people/career/qualification/newCompetency/Show';

const NEW_QM_PATH = '/qualification-models';

const useNewQualificationModelRoute = () => {
  return createRoute({ listRoute: NEW_QM_PATH });
};

const NewCompetencyRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useNewQualificationModelRoute();

  return (
    <ProtectedRouter basePath={NEW_QM_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_NEW_COMPETENCY_LIST}>
              <NewQualificationModelViewPage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

NewCompetencyRouter.getRouterPath = () => `${NEW_QM_PATH}/*`;

export default NewCompetencyRouter;
